<script>
    import UploadImage from '@/components/base-components/UploadImage.vue';
    import { updateAssetTypeImage } from '@/api/assetType.js';

    export default {
        computed: {
            editData() {return this.$store.getters.ASSET_TYPE_DATA_EDIT},
            assetType() {return this.$store.getters.ASSET_TYPE_BY_NAME(this.editData.name)}
        },
        components: {
            UploadImage: UploadImage,
        },
        methods: {
            async updateImage(event) {
                const file = event.target.files[0];
                const response = await updateAssetTypeImage(file, this.editData.id);
                if (response != null) {
                    this.assetType.icon_path = response.url;
                }
            }
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <UploadImage 
            :uploadMethod="updateImage"
        />
        <div class="upload_image_container mt_10">
            <img :src="assetType['icon_path']">
        </div>
    </div>
</template>